import {AlertController, Keyboard, LoadingController} from 'ionic-angular';
import {Component} from '@angular/core';
import {UserService} from '../../services/user.services';
import {AppConfigService} from '../../services/appConfig.service';
import {AppDialog} from "../../component/appDialog";
import { TranslateService } from 'ng2-translate';
@Component({
    templateUrl: 'register.html',
    selector: 'register-page',
})
export class RegisterPage {
    loginName: string;
    pwd: string;
    nickName: string;
    pwdre: string;
    pointssc: number = 0;
    // point115: number = 0;
    // pointdp: number = 0;
    // pointfh: number = 0;
    selssc: any = [];
    // sel115: any = [];
    // seldp: any = [];
    // selfh: any = [];

    constructor(private keyboard: Keyboard, private alertCtrl: AlertController, private userService: UserService, private loadingCtrl: LoadingController, private translate: TranslateService) {
    }

    registerFn() {
        let requestData: any = {
            loginname: this.loginName,
            pwd: this.pwd,
            pwdre: this.pwdre,
            nickname: this.nickName,
            pointssc: this.pointssc,
            // point115: this.point115,
            // pointdp: this.pointdp,
            // pointfh: this.pointfh
        };

        this.userService.agentRegisterSave(requestData, this).then(data => {
            if (!data["msg"]) {
                AppDialog.alert({
                    alertCtrl: this.alertCtrl,
                    message: this.loginName + this.translate.instant("REGISTER_SUCCESS")
                });
                this.initData();
            } else {
                AppDialog.alert({
                    alertCtrl: this.alertCtrl,
                    message: data["msg"]
                });
            }
        });
    }

    initData() {
        this.loginName = "";
        this.pwd = "";
        this.nickName = "";
        this.pwdre = "";
        this.pointssc = 0;
        // this.point115 = 0;
        // this.pointdp = 0;
        // this.pointfh = 0;
    }

    ionViewWillEnter() {
        let requestData: any = {};
        this.userService.agentRegisterInit(requestData, this.alertCtrl).then(data => {
            if (!data["msg"]) {
                this.pointssc = data["pointssc"];
                // this.point115 = data["point115"];
                // this.pointdp = data["pointdp"];
                // this.pointfh = data["pointfh"];
                this.selssc = data["selssc"].sort(function (a, b) {
                    if (a.value < b.value) {
                        return -1;
                    } else if (a.value > b.value) {
                        return 1;
                    } else {
                        return 0;
                    }
                });
                // this.sel115 = data["sel115"];
                // this.seldp = data["seldp"];
                // this.selfh = data["selfh"];
            } else {
                AppDialog.alert({
                    alertCtrl: this.alertCtrl,
                    message: data["msg"]
                });
            }
        });
    }

    ionViewWillLeave() {
        this.keyboard.close();
    }
}



// WEBPACK FOOTER //
// ./src/pages/register/register.ts